export default __webpack_public_path__ + "static/media/image2.2ba3c2748a27d7416cdd0bc1a73dc2f2.png";